module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"all":"All","not":"None"},"no":{"all":"Alle","not":"Ikke"}}')
  delete Component.options._Ctor
}
